import { UiStringModel } from "../../core/models/ui-string.model";
import UrlService from "../../core/services/url.service";
import { EnvModel } from "../../core/models/env.model";
import DataService from "../../core/services/data.service";
import * as $cartHelper from '../../core/helpers/cart.helper';
import { CartSettingModel } from "../../core/models/cart-setting.model";
import { CartModel, TicketModel } from "../../core/models/cart.model";

export class CartViewModel {
    private env: EnvModel;
    private dataService: DataService;
    private cart: CartSettingModel;

    constructor() {
        this.env = (window as any).env as EnvModel;
        this.cart = (window as any).cart as CartSettingModel;
        const uiStrings = (window as any).global.uiStrings as UiStringModel;
        this.uiStrings = ko.observable(uiStrings);

        this.urlService = new UrlService(this.env);
        this.dataService = new DataService(this.env);

        this.dataService.GetShoppingCart()
            .then((response: any) => this.GetShoppingCartSuccessCallback(response), (e: any) => this.GetShoppingCartErrorCallback(e));

    }

    public uiStrings: KnockoutObservable<UiStringModel>;
    public urlService: UrlService;

    public surchargeApplied = ko.observable(0);
    public shoppingCartVm = ko.observable<CartModel>(null);
    public accountId = ko.observable(0);
    public shoppingCartTotalAmount = ko.observable(0); // REVIEW IF CAN BE REMOVED
    public isDataCollectionComplete = ko.observable(0); // REVIEW IF CAN BE REMOVED

    public links = ko.observable({});

    private _onHeightUpdate() {
        setTimeout(() => {
            const height = document.documentElement.offsetHeight;
            parent.postMessage({ action: 'CheckoutScrollHeight', payload: height }, this.env.eventSitePath);
        });
    };

    public methods = ko.observable({
        removeTicketItem: (payload: any) => {
            const rTicketPromise = this.dataService.RemoveTicketItem(payload);

            rTicketPromise.then(() => {
                parent.postMessage({ action: 'RefreshData', payload: null }, this.env.eventSitePath);
                this._onHeightUpdate();
            });

            return rTicketPromise;
        },
        removeDonationItem: (payload: any) => {
            var rDonationPromise = this.dataService.RemoveDonationItem(payload);

            rDonationPromise.then(function () {
                parent.postMessage({ action: 'RefreshData', payload: null }, this.env.eventSitePath);
                this._onHeightUpdate();
            });

            return rDonationPromise;
        },
        removeGCBookingItem: (payload: any) => {
            var rGCPromise = this.dataService.RemoveGCBookingItem(payload);

            rGCPromise.then(() => {
                parent.postMessage({ action: 'RefreshData', payload: null }, this.env.eventSitePath);
                this._onHeightUpdate();
            });

            return rGCPromise;
        },
        onNoCartItems: (lastEventId: number, shouldRedirectToGCPurchase: boolean) => {
            if (shouldRedirectToGCPurchase) {
                var accountId = this.accountId();
                parent.postMessage({ action: 'RedirectToGCPurchase', payload: { shouldRedirectToGCPurchase: shouldRedirectToGCPurchase, accountId: accountId } }, this.env.eventSitePath);
            } else {
                parent.postMessage({ action: 'RedirectToEventLanding', payload: { lastEventId: lastEventId } }, this.env.eventSitePath);
            }
        },
        onBookingTicketRemove: (payload: any) => this.OnBookingTicketRemove(payload),
        onShoppingCartLoaded: () => {
            setTimeout(() => {
                this._onHeightUpdate();
                setTimeout(() => {
                    this._onHeightUpdate();
                });
            });
        },
        completeDataEntry: (data: any) => {
            parent.postMessage({ action: 'RedirectToDataEntry', payload: { eventId: data.eventId, sessionTimeId: data.sessionTimeId, sectionId: data.sectionId } }, this.env.eventSitePath);
        },
        updateCartDetails: (data: any) => {
            parent.postMessage({ action: 'UpdateCartDetails', payload: { cartCount: data.cartCount, cartTotal: data.cartTotal, cartTickets: data.cartTickets! } }, this.env.eventSitePath);
        },
    });

    private GetShoppingCartSuccessCallback(data: CartModel) {
        if (!this.accountId()) {
            this.accountId($cartHelper.GetAccountIdFromCart(data));
            const eventId = $cartHelper.GetFirstEvent(data);

            const _links = $cartHelper.GetCartLinks(
                this.env.bookingSitePath,
                this.env.eventSitePath,
                this.accountId(),
                eventId,
                this.cart.widgetType,
                this.cart.widgetEventId,
                this.cart.isEventListingWidget,
                this.urlService.GetActiveQueryString());

            this.links(_links);
        }

        this.shoppingCartVm(data);
    }

    private GetShoppingCartErrorCallback(e: any) {
        console.error(e);
    }

    // REVIEW IF THIS CAN BE MOVED TO SHOPPING CART VIEW MODEL
    private OnBookingTicketRemove(shoppingCartData: any) {
        // DO NOTHING
    };

}
